// Comprehensive list of time zones with UTC offsets
export const TIME_ZONES = [
    // UTC and GMT
    { label: 'GMT+00:00) UTC', value: 'UTC', offset: 0 },
    { label: 'GMT+00:00) Etc/GMT', value: 'Etc/GMT', offset: 0 },
    
    // Africa
    { label: 'GMT+01:00) Africa/Algiers', value: 'Africa/Algiers', offset: 1 },
    { label: 'GMT+01:00) Africa/Lagos', value: 'Africa/Lagos', offset: 1 },
    { label: 'GMT+01:00) Africa/Casablanca', value: 'Africa/Casablanca', offset: 1 },
    { label: 'GMT+02:00) Africa/Cairo', value: 'Africa/Cairo', offset: 2 },
    { label: 'GMT+02:00) Africa/Johannesburg', value: 'Africa/Johannesburg', offset: 2 },
    { label: 'GMT+02:00) Africa/Harare', value: 'Africa/Harare', offset: 2 },
    { label: 'GMT+03:00) Africa/Nairobi', value: 'Africa/Nairobi', offset: 3 },
    
    // America - North America
    { label: 'GMT-10:00) America/Adak', value: 'America/Adak', offset: -10 },
    { label: 'GMT-09:00) America/Anchorage', value: 'America/Anchorage', offset: -9 },
    { label: 'GMT-08:00) America/Los_Angeles', value: 'America/Los_Angeles', offset: -8 },
    { label: 'GMT-08:00) America/Vancouver', value: 'America/Vancouver', offset: -8 },
    { label: 'GMT-07:00) America/Denver', value: 'America/Denver', offset: -7 },
    { label: 'GMT-07:00) America/Phoenix', value: 'America/Phoenix', offset: -7 },
    { label: 'GMT-07:00) America/Edmonton', value: 'America/Edmonton', offset: -7 },
    { label: 'GMT-06:00) America/Chicago', value: 'America/Chicago', offset: -6 },
    { label: 'GMT-06:00) America/Mexico_City', value: 'America/Mexico_City', offset: -6 },
    { label: 'GMT-06:00) America/Winnipeg', value: 'America/Winnipeg', offset: -6 },
    { label: 'GMT-05:00) America/New_York', value: 'America/New_York', offset: -5 },
    { label: 'GMT-05:00) America/Toronto', value: 'America/Toronto', offset: -5 },
    { label: 'GMT-05:00) America/Lima', value: 'America/Lima', offset: -5 },
    { label: 'GMT-05:00) America/Bogota', value: 'America/Bogota', offset: -5 },
    { label: 'GMT-04:00) America/Halifax', value: 'America/Halifax', offset: -4 },
    { label: 'GMT-04:00) America/Caracas', value: 'America/Caracas', offset: -4 },
    { label: 'GMT-04:00) America/Santiago', value: 'America/Santiago', offset: -4 },
    { label: 'GMT-03:30) America/St_Johns', value: 'America/St_Johns', offset: -3.5 },
    { label: 'GMT-03:00) America/Sao_Paulo', value: 'America/Sao_Paulo', offset: -3 },
    { label: 'GMT-03:00) America/Buenos_Aires', value: 'America/Buenos_Aires', offset: -3 },
    { label: 'GMT-03:00) America/Godthab', value: 'America/Godthab', offset: -3 },
    
    // Asia
    { label: 'GMT+02:00) Asia/Amman', value: 'Asia/Amman', offset: 2 },
    { label: 'GMT+02:00) Asia/Beirut', value: 'Asia/Beirut', offset: 2 },
    { label: 'GMT+02:00) Asia/Jerusalem', value: 'Asia/Jerusalem', offset: 2 },
    { label: 'GMT+03:00) Asia/Baghdad', value: 'Asia/Baghdad', offset: 3 },
    { label: 'GMT+03:00) Asia/Kuwait', value: 'Asia/Kuwait', offset: 3 },
    { label: 'GMT+03:00) Asia/Riyadh', value: 'Asia/Riyadh', offset: 3 },
    { label: 'GMT+03:30) Asia/Tehran', value: 'Asia/Tehran', offset: 3.5 },
    { label: 'GMT+04:00) Asia/Dubai', value: 'Asia/Dubai', offset: 4 },
    { label: 'GMT+04:00) Asia/Baku', value: 'Asia/Baku', offset: 4 },
    { label: 'GMT+04:30) Asia/Kabul', value: 'Asia/Kabul', offset: 4.5 },
    { label: 'GMT+05:00) Asia/Karachi', value: 'Asia/Karachi', offset: 5 },
    { label: 'GMT+05:00) Asia/Tashkent', value: 'Asia/Tashkent', offset: 5 },
    { label: 'GMT+05:30) Asia/Kolkata', value: 'Asia/Kolkata', offset: 5.5 },
    { label: 'GMT+05:30) Asia/Colombo', value: 'Asia/Colombo', offset: 5.5 },
    { label: 'GMT+05:45) Asia/Kathmandu', value: 'Asia/Kathmandu', offset: 5.75 },
    { label: 'GMT+06:00) Asia/Dhaka', value: 'Asia/Dhaka', offset: 6 },
    { label: 'GMT+06:00) Asia/Almaty', value: 'Asia/Almaty', offset: 6 },
    { label: 'GMT+06:30) Asia/Yangon', value: 'Asia/Yangon', offset: 6.5 },
    { label: 'GMT+07:00) Asia/Bangkok', value: 'Asia/Bangkok', offset: 7 },
    { label: 'GMT+07:00) Asia/Jakarta', value: 'Asia/Jakarta', offset: 7 },
    { label: 'GMT+07:00) Asia/Ho_Chi_Minh', value: 'Asia/Ho_Chi_Minh', offset: 7 },
    { label: 'GMT+08:00) Asia/Hong_Kong', value: 'Asia/Hong_Kong', offset: 8 },
    { label: 'GMT+08:00) Asia/Singapore', value: 'Asia/Singapore', offset: 8 },
    { label: 'GMT+08:00) Asia/Shanghai', value: 'Asia/Shanghai', offset: 8 },
    { label: 'GMT+08:00) Asia/Taipei', value: 'Asia/Taipei', offset: 8 },
    { label: 'GMT+08:00) Asia/Manila', value: 'Asia/Manila', offset: 8 },
    { label: 'GMT+08:45) Australia/Eucla', value: 'Australia/Eucla', offset: 8.75 },
    { label: 'GMT+09:00) Asia/Tokyo', value: 'Asia/Tokyo', offset: 9 },
    { label: 'GMT+09:00) Asia/Seoul', value: 'Asia/Seoul', offset: 9 },
    { label: 'GMT+09:30) Australia/Darwin', value: 'Australia/Darwin', offset: 9.5 },
    { label: 'GMT+09:30) Australia/Adelaide', value: 'Australia/Adelaide', offset: 9.5 },
    { label: 'GMT+10:00) Australia/Sydney', value: 'Australia/Sydney', offset: 10 },
    { label: 'GMT+10:00) Australia/Brisbane', value: 'Australia/Brisbane', offset: 10 },
    { label: 'GMT+10:00) Australia/Melbourne', value: 'Australia/Melbourne', offset: 10 },
    { label: 'GMT+10:30) Australia/Lord_Howe', value: 'Australia/Lord_Howe', offset: 10.5 },
    { label: 'GMT+11:00) Pacific/Guadalcanal', value: 'Pacific/Guadalcanal', offset: 11 },
    { label: 'GMT+12:00) Pacific/Auckland', value: 'Pacific/Auckland', offset: 12 },
    { label: 'GMT+12:00) Pacific/Fiji', value: 'Pacific/Fiji', offset: 12 },
    { label: 'GMT+13:00) Pacific/Tongatapu', value: 'Pacific/Tongatapu', offset: 13 },
    { label: 'GMT+14:00) Pacific/Kiritimati', value: 'Pacific/Kiritimati', offset: 14 },
    
    // Europe
    { label: 'GMT+00:00) Europe/London', value: 'Europe/London', offset: 0 },
    { label: 'GMT+00:00) Europe/Dublin', value: 'Europe/Dublin', offset: 0 },
    { label: 'GMT+00:00) Europe/Lisbon', value: 'Europe/Lisbon', offset: 0 },
    { label: 'GMT+01:00) Europe/Paris', value: 'Europe/Paris', offset: 1 },
    { label: 'GMT+01:00) Europe/Berlin', value: 'Europe/Berlin', offset: 1 },
    { label: 'GMT+01:00) Europe/Rome', value: 'Europe/Rome', offset: 1 },
    { label: 'GMT+01:00) Europe/Madrid', value: 'Europe/Madrid', offset: 1 },
    { label: 'GMT+01:00) Europe/Amsterdam', value: 'Europe/Amsterdam', offset: 1 },
    { label: 'GMT+01:00) Europe/Brussels', value: 'Europe/Brussels', offset: 1 },
    { label: 'GMT+01:00) Europe/Vienna', value: 'Europe/Vienna', offset: 1 },
    { label: 'GMT+01:00) Europe/Prague', value: 'Europe/Prague', offset: 1 },
    { label: 'GMT+01:00) Europe/Warsaw', value: 'Europe/Warsaw', offset: 1 },
    { label: 'GMT+02:00) Europe/Athens', value: 'Europe/Athens', offset: 2 },
    { label: 'GMT+02:00) Europe/Bucharest', value: 'Europe/Bucharest', offset: 2 },
    { label: 'GMT+02:00) Europe/Helsinki', value: 'Europe/Helsinki', offset: 2 },
    { label: 'GMT+02:00) Europe/Istanbul', value: 'Europe/Istanbul', offset: 2 },
    { label: 'GMT+02:00) Europe/Kiev', value: 'Europe/Kiev', offset: 2 },
    { label: 'GMT+03:00) Europe/Moscow', value: 'Europe/Moscow', offset: 3 },
    { label: 'GMT+03:00) Europe/Minsk', value: 'Europe/Minsk', offset: 3 },
    
    // Pacific
    { label: 'GMT-11:00) Pacific/Midway', value: 'Pacific/Midway', offset: -11 },
    { label: 'GMT-11:00) Pacific/Samoa', value: 'Pacific/Samoa', offset: -11 },
    { label: 'GMT-10:00) Pacific/Honolulu', value: 'Pacific/Honolulu', offset: -10 },
    { label: 'GMT-09:00) Pacific/Gambier', value: 'Pacific/Gambier', offset: -9 },
    { label: 'GMT-09:30) Pacific/Marquesas', value: 'Pacific/Marquesas', offset: -9.5 },
    { label: 'GMT-08:00) Pacific/Pitcairn', value: 'Pacific/Pitcairn', offset: -8 },
    { label: 'GMT+11:00) Pacific/Noumea', value: 'Pacific/Noumea', offset: 11 },
    { label: 'GMT+12:45) Pacific/Chatham', value: 'Pacific/Chatham', offset: 12.75 },
    
    // Atlantic
    { label: 'GMT-01:00) Atlantic/Azores', value: 'Atlantic/Azores', offset: -1 },
    { label: 'GMT-02:00) Atlantic/South_Georgia', value: 'Atlantic/South_Georgia', offset: -2 },
    { label: 'GMT-04:00) Atlantic/Bermuda', value: 'Atlantic/Bermuda', offset: -4 },
    
    // Indian Ocean
    { label: 'GMT+04:00) Indian/Mauritius', value: 'Indian/Mauritius', offset: 4 },
    { label: 'GMT+05:00) Indian/Maldives', value: 'Indian/Maldives', offset: 5 },
];

export default TIME_ZONES;
